export default {
  "Query": [
    "categories",
    "commTemplatesConnection",
    "callActivityConnection",
    "ordersConnection",
    "promotionsConnection",
    "consumerExpertReviewConnection",
    "expertApplicationsConnection",
    "expertApplicationsPendingReview",
    "expertSearchConnection",
    "expertApplicationFolderItems",
    "brands",
    "savedSellablesConnection",
    "searchSellables",
    "consumerSellableReactions",
    "leads",
    "expertLeadFolderItems",
    "runLeadSavedSearch",
    "expertCuratedOrdersForLeadConnection",
    "expertCuratedOrderListActivationsForLead",
    "popularExpertCuratedItemsForSellable",
    "suggestExpertCuratedItemNotes",
    "suggestExpertCuratedItemsForLead",
    "suggestedAlternativeSellables",
    "searchSuggestedAlternativeSellables",
    "departmentExpertCuratedActivityFeed",
    "expertExpertCuratedActivityFeed",
    "searchRecentExpertCuratedItemGroups",
    "searchSavedExpertCuratedItems",
    "sellableExpertCuratedItemNoteStatsConnection",
    "recommendedListsForCategory",
    "recommendedLists",
    "recommendedListDefinitions",
    "triggersConnection",
    "searchEBayItems",
    "findSupportTasks",
    "findSupportTasksForOperatorFolder",
    "orderEscalations",
    "supportConversationsConnection",
    "rawSellableSearchConnection",
    "fulfillmentCenters",
    "fulfillmentShipmentMethods",
    "findFulfillmentChannels",
    "orderRefundsConnection",
    "ticketsConnection",
    "searchTickets",
    "bookingsConnection",
    "searchArticles",
    "searchProductCatalogs"
  ],
  "User": [
    "consumerExpertReviewConnection"
  ],
  "BusinessUser": [
    "consumerExpertReviewConnection",
    "activityConnection"
  ],
  "Sellable": [
    "consumerSellableReactions",
    "recommendingExperts"
  ],
  "PathFlow": [
    "pagesConnection"
  ],
  "Department": [
    "consumerExpertReviewConnection"
  ],
  "ExpertCuratedItemsForLeadPayload": [
    "activationsConnection"
  ],
  "RecommendedList": [
    "sellableConnection"
  ],
  "RecommendedListDefinition": [
    "previewResults"
  ],
  "ExpertCuratedOrdersForLeadConnectionChangedPayload": [
    "connection"
  ]
}